import Box from "ds/components/Box";
import Link from "ds/components/Link";
import TextEllipsis from "ds/components/TextEllipsis";
import { encodeApiKeyId } from "shared/ApiKey/urlHelpers";

import { CellComponentProps } from "../types";

type ApiKeysListItemNameCellProps = CellComponentProps;

const ApiKeysListItemNameCell = ({ apiKey }: ApiKeysListItemNameCellProps) => {
  return (
    <Box fullWidth gap="large">
      <TextEllipsis tooltip={apiKey.name} tooltipWidthMode="maxWidthSm">
        {(props) => (
          <Link {...props} href={`/settings/api-key/${encodeApiKeyId(apiKey.id)}`} variant="secondary" size="small">
            {apiKey.name}
          </Link>
        )}
      </TextEllipsis>
    </Box>
  );
};

export default ApiKeysListItemNameCell;